import {language} from './site-languages.js';
export function createTermsPage(React){
 const h=React.createElement;
 return function TermsPage(){
  const [copy,setCopy]=React.useState(null);
  const [failed,setFailed]=React.useState(false);
  React.useEffect(()=>{
   let active=true;
   import('./terms-copy.js').then(({termsCopy})=>{
    if(!active)return;
    if(!termsCopy[language]){window.location.replace('/tos/');return;}
    setCopy(termsCopy[language]);
   }).catch(()=>{if(active)setFailed(true);});
   return()=>{active=false;};
  },[]);
  if(!copy)return h('article',{className:'locale-guide',style:{padding:'24px',width:'100%'}},failed?h('button',{onClick:()=>window.location.reload()},'Retry'):h('p',{role:'status'},'…'));
  return h('article',{className:'locale-guide',style:{padding:'24px',width:'100%'}},h('h1',{style:{fontSize:'36px'}},copy.title),...copy.sections.map(([title,body],i)=>h('section',{key:i},h('h2',null,`${i+1}. ${title}`),h('p',null,body))));
 };
}
